import * as React from 'react'
import {Lang} from 'yougile-lang'
import {GTDStage, TaskData} from 'yougile-model'
import {logger, Util} from 'yougile-util'
import {UserProxy} from '../../../extensions/proxies/user-proxy'
import {ErrorBoundary} from '../../common/error-boundary/error-boundary'
import {StatsTask} from '../stats-task/stats-task'

interface Props {
  user?: UserProxy | undefined
  tasks: TaskData[]
  stage: GTDStage
  paging?: number
}

interface State {
  maxShownOpenTasks: number
  expanded: boolean
}

export class ByUserColumnStage extends React.Component<Props, State> {
  public override state: State = {
    maxShownOpenTasks: this.props.paging || 5,
    expanded: ['current', 'new'].indexOf(this.props.stage) > -1
  }

  private toggle = () => this.setState(prev => ({expanded: !prev.expanded}))

  private showMoreOpenTasks = () =>
    this.setState(prev => ({
      maxShownOpenTasks: prev.maxShownOpenTasks + (this.props.paging || 5)
    }))

  public override render(): JSX.Element {
    const {user, tasks, stage} = this.props
    const {maxShownOpenTasks, expanded} = this.state
    const bem = Util.bemFrom('by-user-column-stage')
    const allTasks = tasks
      .filter(task =>
        user ? task.assigned.indexOf(user.userId) > -1 : !task.assigned
      )
      .filter(
        task =>
          task.gtdStage === stage ||
          (stage !== 'done' && task.gtdStage !== 'done')
      )
    const renderCard = (task: TaskData) => {
      const onError = () => logger.warn('Error with stat item', task)
      return (
        <ErrorBoundary key={task.id} silent={true} onError={onError}>
          <StatsTask task={task} showUnseen={!!user} />
        </ErrorBoundary>
      )
    }
    const unassignedSort = (t1: TaskData, t2: TaskData) =>
      +t2.createTime - +t1.createTime
    const compareTasks = (a: TaskData, b: TaskData) =>
      stage === 'done'
        ? b.completeTime - a.completeTime
        : b.assignTime - a.assignTime
    const sortedTasks = !user
      ? allTasks.sort(unassignedSort)
      : [...allTasks].sort(compareTasks)
    const shownOpenTasks = sortedTasks
      .slice(0, maxShownOpenTasks)
      .map(renderCard)

    const moreTasks = sortedTasks.length - shownOpenTasks.length

    if (allTasks.length === 0) {
      return null
    }

    return (
      <div className={bem({expanded})}>
        {!!user && (
          <div className={bem('title')} onClick={this.toggle}>
            {Lang.findMsg('myTasks' + Util.capitalize(stage))} (
            {allTasks.length})
          </div>
        )}
        {expanded && (
          <div className={bem('content')}>
            {shownOpenTasks}
            {moreTasks > 0 && (
              <ByUserShowMore
                moreCount={moreTasks}
                showMore={this.showMoreOpenTasks}
              />
            )}
          </div>
        )}
      </div>
    )
  }
}

interface ShowMoreProps {
  moreCount: number
  showMore: () => void
}
const ByUserShowMore = (props: ShowMoreProps) => {
  const {showMore, moreCount} = props
  const bem = Util.bemFrom('by-user-column-stage')
  return (
    <div className={bem('show-more')}>
      <div className={bem('more-text')}>
        {Lang.msg.moreTasks} <div className={bem('more-num')}>{moreCount}</div>
      </div>
      <div className={bem('more-btn')} onClick={showMore}>
        {Lang.msg.showMore2}
      </div>
    </div>
  )
}
